"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateQuoteComparisonReportDto = exports.QuoteComparisonReportDocumentDto = exports.PlacementDynamicsSectionDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class PlacementDynamicsSectionDto {
}
exports.PlacementDynamicsSectionDto = PlacementDynamicsSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Competitive rates observed in the market.",
        description: "Insurance market overview",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "insuranceMarket", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Client requested additional coverage.",
        description: "Client specific details",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "clientSpecific", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Delay in receiving quotes from insurer.",
        description: "Issues faced during placement",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "issuesFaced", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Rates are in line with industry standards.",
        description: "Industry benchmarking comments",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "industryBenchmarkingComments", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Recommend proceeding with Insurer A.",
        description: "Analysis and recommendation",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "analysisRecommendation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "All quotes reviewed and compared.",
        description: "Overall comments",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "overallComments", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "This is my insurer data",
        description: "Additional remarks",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], PlacementDynamicsSectionDto.prototype, "remarks", void 0);
class QuoteComparisonReportDocumentDto {
}
exports.QuoteComparisonReportDocumentDto = QuoteComparisonReportDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 555,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], QuoteComparisonReportDocumentDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type LID",
        example: 2,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], QuoteComparisonReportDocumentDto.prototype, "documentTypeLid", void 0);
class CreateQuoteComparisonReportDto {
}
exports.CreateQuoteComparisonReportDto = CreateQuoteComparisonReportDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteComparisonReportDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 403,
        description: "Status LID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreateQuoteComparisonReportDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: PlacementDynamicsSectionDto,
        required: true,
        description: "Placement Dynamics Section",
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => PlacementDynamicsSectionDto),
    tslib_1.__metadata("design:type", PlacementDynamicsSectionDto)
], CreateQuoteComparisonReportDto.prototype, "placementDynamicsSetion", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [QuoteComparisonReportDocumentDto],
        description: "Array of documents",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => QuoteComparisonReportDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreateQuoteComparisonReportDto.prototype, "documents", void 0);
